import { Pucks } from 'app/features/configuratorData/slice/types';
import { ItemsPriceType } from 'app/features/price/slice/types';
import { StockStatusType } from 'app/features/stock/slice/types';

export const transformPucksDTO: (
  pucks: Pucks[],
  pucksPrice: Array<ItemsPriceType>,
  pucksStockStatus: Array<StockStatusType>,
) => any = (
  pucks: Pucks[],
  pucksPrice: Array<ItemsPriceType>,
  pucksStockStatus: Array<StockStatusType>,
) => {
  const transformedPucks: Pucks[] = pucks.map(item => {
    const stock = pucksStockStatus?.find(
      stockItem => stockItem.number === item.erpPartNumber,
    );
    const price = pucksPrice?.find(
      priceItem => priceItem.number === item.erpPartNumber,
    );
    return {
      ...item,
      stockStatus: stock,
      price: price,
    };
  });

  return transformedPucks;
};
